<template>
  <div class="sticky top-[-1.5rem] left-0 w-full bg-capino-light z-[3]">
    <div class="pb-1 gap-2 flex flex-col">
      <span class="pl-4 sm:pl-8 text-base font-bold text-[#7C7C7C]">{{
        $t('hub.sections.sections')
      }}</span>

      <div
        class="w-full gap-2 flex flex-nowrap overflow-x-auto sm:px-8 sm:flex-wrap"
      >
        <SectionsChipsItem
          v-for="chip of chips"
          :key="chip.slug"
          class="first:ml-4 sm:first:ml-8 sm:!ml-0"
          :chip="chip"
          :is-active="chip.slug === filters.sectionSlug"
          @click="chip.handler"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SectionsChipsItem from '@/components/Hub/Sections/SectionsChipsItem.vue'

export default {
  name: 'HubSectionsChips',

  components: { SectionsChipsItem },

  props: {
    filters: { type: Object, required: true },
    sections: { type: Array, required: true },
    filteredSections: { type: Array, required: true }
  },

  computed: {
    list() {
      return this.filters.search ? this.filteredSections : this.sections
    },

    chips() {
      return [
        {
          name: 'All',
          slug: 'all',
          handler: () => this.handleChipClick('all')
        },
        ...this.list
          .map(section => ({
            name: section.name,
            slug: section.slug,
            handler: () => this.handleChipClick(section.slug)
          }))
          .filter(chip => !['tutorial', 'playground'].includes(chip.slug))
      ]
    }
  },

  methods: {
    handleChipClick(slug) {
      this.$emit('update:filters', { ...this.filters, sectionSlug: slug })
    }
  }
}
</script>
